import React from 'react'
import { Balloon } from './styles'
import { BalloonHintProps, PropDefaults } from './types'

export const BalloonHint = (props: BalloonHintProps) => {
  const {
    bgColor,
    className,
    fontColor,
    fontSize,
    margin,
    parentHeight,
    parentOffset,
    position,
    hintContents,
    width
  } = { ...PropDefaults, ...props }

  return (
    <Balloon
      className={className}
      {...{
        bgColor,
        fontColor,
        fontSize,
        margin,
        parentHeight,
        parentOffset,
        position,
        width
      }}
    >
      <div className='balloonTip' />
      <div className='contents'>{hintContents}</div>
    </Balloon>
  )
}
